<div
  [ngClass]="styleClass"
  [ngStyle]="{ 'background-color': backgroundColor, color: textColor }"
  [pTooltip]="isShowTooltip ? name : null"
  tooltipPosition="left"
  class="inline-block py-2 px-3 border-round text-center font-bold uppercase {{
    isTruncateStatus ? 'truncate-status' : ''
  }}">
  {{ name }}
</div>
